/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePrescriptionResponseDto
 */
export interface CreatePrescriptionResponseDto {
    /**
     * Indicates if the prescription was created successfully
     * @type {boolean}
     * @memberof CreatePrescriptionResponseDto
     */
    success: boolean;
    /**
     * Success message
     * @type {string}
     * @memberof CreatePrescriptionResponseDto
     */
    message: string;
    /**
     * The ID of the created prescription
     * @type {string}
     * @memberof CreatePrescriptionResponseDto
     */
    prescriptionId: string;
}

/**
 * Check if a given object implements the CreatePrescriptionResponseDto interface.
 */
export function instanceOfCreatePrescriptionResponseDto(value: object): value is CreatePrescriptionResponseDto {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('prescriptionId' in value) || value['prescriptionId'] === undefined) return false;
    return true;
}

export function CreatePrescriptionResponseDtoFromJSON(json: any): CreatePrescriptionResponseDto {
    return CreatePrescriptionResponseDtoFromJSONTyped(json, false);
}

export function CreatePrescriptionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePrescriptionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'prescriptionId': json['prescriptionId'],
    };
}

export function CreatePrescriptionResponseDtoToJSON(json: any): CreatePrescriptionResponseDto {
    return CreatePrescriptionResponseDtoToJSONTyped(json, false);
}

export function CreatePrescriptionResponseDtoToJSONTyped(value?: CreatePrescriptionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'prescriptionId': value['prescriptionId'],
    };
}

